import React                     from 'react'
import classnames                from 'classnames';
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome';

import IconEnoughStock          from 'images/bom/stock.png'
import IconNoEnoughStock        from 'images/bom/no-enough-stock.png'
import IconNoStock               from 'images/bom/no-stock.png'
import IconUnknownMountingType   from 'images/bom/unknown-mounting-type.png'

import {Doughnut} from 'react-chartjs-2';

const PartStatusGraph = (props) => {
  var part_value = props.value;
  var rest_value = props.num_parts - props.value;

  const data = {
    datasets: [{
      data: [rest_value, part_value],
      backgroundColor: [
      '#e1e5e8',
      props.background,
      ],
      hoverBackgroundColor: [
      '#e1e5e8',
      props.background,
      ]
    }]
  };

  const options = {
    responsive: true,
    tooltips: {
      enabled: false
    },
    cutoutPercentage: 70,
  }

  return(
    <Doughnut data={data}
     options={options}
     height={70}
     width={70} />
  )
}

const PartStatusReport = (props) => {
  const status = props.report[props.selected_quantity];
  
  return(
    <div className="part-status-report">
      <div className="d-flex align-items-top">
        <div className="col-4 part-status-section">
          <div className="graph">
            <PartStatusGraph 
              background="#3e9b55"
              num_parts={props.num_parts}
              value={status.enough_stock}/>
            <span className="enough-stock">
              {status.enough_stock}
            </span>
          </div>
          <div className="caption d-flex">
            <div>
              <img className="icon-part-status" 
               src={IconEnoughStock} alt="Enought Stock" />
            </div>
            <div>Enough Stock</div>
          </div>
        </div>
        <div className="col-4 part-status-section">
          <div className="graph">
            <PartStatusGraph 
              background="#ee5b24"
              num_parts={props.num_parts}
              value={status.no_enough_stock}/>
            <span className="no-enough-stock">
              {status.no_enough_stock}
            </span>
          </div>
          <div className="caption d-flex">
            <div>
              <img className="icon-part-status" 
               src={IconNoEnoughStock} alt="No Enought Stock" />
            </div>
            <div>No Enough Stock</div>
          </div>
        </div>
        <div className="col-4 part-status-section">
          <div className="graph">
            <PartStatusGraph 
                background="#be272e"
                num_parts={props.num_parts}
                value={status.no_stock}/>
            <span className="no-stock">
              {status.no_stock}
            </span>
          </div>
          <div className="caption d-flex">
            <div>
              <img className="icon-part-status" 
              src={IconNoStock} alt="No Stock" />
            </div>
            <div>
              No Stock <br/>
              & Not available
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const VendorReport = (props) => {
  const vendor_report = props.report[props.selected_quantity];
  const num_parts= props.num_parts;
  var report = [];

  Object.entries(vendor_report).forEach(([key, value]) => {
    var percent = Math.round((value/num_parts)*100);
    report.push(
      <tr key={"vendor-" + key + "-report"}>
        <td className="vendor">
          {key}
        </td>
        <td className="stats">
          <div className="">
            <span className="percent">{percent}%</span>
            <div className="progress">
              <div className="progress-bar" role="progressbar" 
               style={{width: percent + '%'}} 
               aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>
        </td>
      </tr>
    )
  });

  return(
    <div className="vendor-report">
      <div className="title">
        Parts Stock by Vendor
      </div>
      <div className="statistics">
        <table className="table table-borderless">
          <tbody>
            {report}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const UnknownMountingType = (props) =>{
  if (props.qty == 0){
    return null;
  }

  return(
    <div className="unknown-mounting-type">
      <img className="icon-bom-admin" src={IconUnknownMountingType} alt="Unknown Mounting Type" /> 
      Unknown Mounting Type 
      <span className="badge">{props.qty}</span>
    </div>
  )
}

const BoardSummary = (props) => {
  return(
    <div className="board-summary">
      <div className="title">
        Summary Per Board
      </div>
      <div className="statistics">
        <table className="table table-borderless">
          <tbody>
            <tr>
              <td>Line Items</td>
              <td className="text-end">
                {props.summary.bom_line_items}
              </td>
            </tr>
            <tr>
              <td>SMT Placements</td>
              <td className="text-end">
                {props.summary.smt}
              </td>
            </tr>
            <tr>
              <td>THT Placements</td>
              <td className="text-end">
                {props.summary.thru_hole}
              </td>
            </tr>
            <tr>
              <td>QFN Placements</td>
              <td className="text-end">
                {props.summary.qfn}
              </td>
            </tr>
            <tr>
              <td>BGA Placements</td>
              <td className="text-end">
                {props.summary.bga}
              </td>
            </tr>
          </tbody>
        </table>
        <UnknownMountingType 
          qty={props.summary.unknown_mounting_type} />
      </div>
    </div>
  )
}

const TotalSummary = (props) => {
  var total_price = numeral(0).format('0.00')
  var unit_price = numeral(0).format('0.00')
  if (props.totals !== undefined
      && Object.keys(props.totals).length !== 0 
      && props.totals[props.selected_quantity] !== undefined){
        let total = props.totals[props.selected_quantity]
        total_price = numeral(total).format('0.00')
        unit_price = numeral(total/props.selected_quantity).format('0.00')
  }
  return(
    <div className="total-summary text-end">
      <div className="total-price">
        <div className="title">
          TOTAL PART COST
        </div>
        <div>
          <div className="value">
            ${total_price}
          </div>
        </div>
      </div>
      <div className="unit-price">
        <div className="title">
          Parts Cost Per Board
        </div>
        <div>
          <div className="value">
            ${unit_price}
          </div>
        </div>
      </div>
    </div>
  )
}

const BomReport = (props) => {
  return(
    <div className="bom-report d-flex align-items-stretch">
      <div className="section col-4">
        <PartStatusReport
          num_parts={props.report.assembly_parameters.bom_line_items}
          report={props.report.status} 
          selected_quantity={props.selected_quantity} />
      </div>
      <div className="section col-3">
        <VendorReport 
         vendors={props.vendors}
         report={props.report.vendor}
         num_parts={props.report.assembly_parameters.bom_line_items} 
         selected_quantity={props.selected_quantity} />
      </div>
      <div className="section col-3">
        <BoardSummary 
         summary={props.report.assembly_parameters} />
      </div>
      <div className="section col-2">
        <TotalSummary
         totals={props.totals} 
         quantities={props.quantities} 
         selected_quantity={props.selected_quantity} />
      </div>
    </div>
  )
}


export default BomReport;
